import { render } from "./EventSetupView.vue?vue&type=template&id=4a555b1f&scoped=true"
import script from "./EventSetupView.vue?vue&type=script&lang=js"
export * from "./EventSetupView.vue?vue&type=script&lang=js"

import "./EventSetupView.vue?vue&type=style&index=0&id=4a555b1f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a555b1f"]])

export default __exports__